<template>
  <div>
    <AppLoader v-if="isLoading" class="text-center" small />
    <b-container fluid>
      <b-navbar toggleable="lg" type="dark" variant="light">
        <b-navbar-brand href="#" class="text-dark">
          <strong>PRI Control Groups Population</strong>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                variant="outline-primary"
                size="sm"
                @click="showModal = !showModal"
                class="mx-2"
              >
                <font-awesome-icon icon="plus" />
              </b-button>

              <b-button variant="outline-info" size="sm" @click="reloadTable">
                <font-awesome-icon icon="sync" />
              </b-button>
              <b-form-group
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <b-table
        class="mx-1"
        bordered
        sticky-header="calc(100vh - 200px)"
        ref="table"
        id="my-table"
        :fixed="true"
        :busy.sync="isLoading"
        :items="getControlGrouppopulationTableData"
        :fields="tableFields"
        :filter="filter"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        responsive="sm"
      >
        <template v-slot:cell(actions)="data">
          <b-button
            size="sm"
            class="mr-2"
            type="button"
            variant="outline-info"
            @click="onEditControlGroup(data)"
          >
            <font-awesome-icon v-b-tooltip.hover title="Edit Field" icon="edit" />
          </b-button>
          <b-button
            size="sm"
            type="button"
            variant="outline-danger"
            @click="onDeleteControlGroupModal(data)"
          >
            <font-awesome-icon v-b-tooltip.hover title="Delete Field" icon="trash" />
          </b-button>
        </template>
      </b-table>
      <b-row>
        <b-col cols="2">
          <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
        </b-col>
        <b-col>
          <b-pagination
            class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
            aria-controls="my-table"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      scrollable
      size="xl"
      :title="editControlGroup ? 'Update Control Groups Population' : 'Create Control Groups Population'"
      v-model="showModal"
    >
      <AppLoader v-if="isLoadingThirdParty" class="text-center" small />
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-row>
            <b-col cols="12">
              <b-form-group label="Select Control Group:">
                <b-form-checkbox-group
                  v-model="$v.form.selectedControlGroup.$model"
                  :state="$v.form.selectedControlGroup.$dirty ? !$v.form.selectedControlGroup.$error : null"
                  :options="controlGroupOptions"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-navbar toggleable="lg" type="dark" variant="light">
                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                <b-navbar-brand href="#" class="text-dark">
                  <strong>Select Third Parties</strong>
                </b-navbar-brand>

                <b-collapse id="nav-collapse" is-nav>
                  <!-- Right aligned nav items -->
                  <b-navbar-nav class="ml-auto">
                    <b-nav-form>
                      <b-form-group
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="filterInput"
                      >
                        <b-input-group size="sm">
                          <b-form-input
                            v-model="thirdPartyFilter"
                            type="search"
                            placeholder="Type to Search"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button
                              :disabled="!thirdPartyFilter"
                              @click="thirdPartyFilter = ''"
                            >Clear</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-nav-form>
                  </b-navbar-nav>
                </b-collapse>
              </b-navbar>
              <AppLoader v-if="thirdPartyIsLoading" class="text-center" small />
              <b-table
                class="mx-1"
                bordered
                ref="table"
                id="my-table"
                :busy.sync="thirdPartyIsLoading"
                :items="getThirdPartiesList"
                :fields="thirdPartyFields"
                :sort-by.sync="thirdPartySortBy"
                :sort-desc.sync="thirdPartySortDesc"
                responsive="sm"
                :per-page="thirdPartyPerPage"
                :current-page="thirdPartyCurrentPage"
                :filter="thirdPartyFilter"
              >
                <template v-slot:cell(selectThirdParty)="data">
                  <b-button variant="primary" @click="onSelectedThirdParty(data)">>>></b-button>
                </template>
              </b-table>
              <p class="mt-3">Current Page: {{ thirdPartyPerPage }} rows</p>
              <b-row>
                <b-col cols="2">
                  <b-form-select
                    v-model="thirdPartyPerPage"
                    id="thirdPartyPerPageSelect"
                    size="sm"
                    :options="thirdPartyPageOptions"
                  ></b-form-select>
                </b-col>
                <b-col>
                  <b-pagination
                    class="float-right"
                    v-model="thirdPartyCurrentPage"
                    :total-rows="thirdPartyRows"
                    :per-page="thirdPartyPerPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    aria-controls="my-table"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6">
              <p>Selected Third Party List</p>
              <b-table-simple bordered responsive="sm">
                <b-thead>
                  <b-tr>
                    <b-th>Index</b-th>
                    <b-th>Third Party Name</b-th>
                    <b-th>Actions</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="(thirdPartyName,index) in selectedThirdPartyName" :key="index">
                    <b-td>{{ index+1+'.' }}</b-td>
                    <b-td>{{ thirdPartyName }}</b-td>
                    <b-td>
                      <b-button
                        size="sm"
                        variant="outline-danger"
                        @click="deleteSelectedThirdParty(index)"
                      >
                        <font-awesome-icon
                          v-b-tooltip.hover
                          title="Delete Answer"
                          icon="trash"
                          :class="'text-danger'"
                        />
                      </b-button>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
          </b-row>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>{{editControlGroup ? 'Your Control Group Population is being Updating......' : 'Your Control Group Population is being Creating......'}}</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{ editControlGroup ? 'Your Control Group Population has been updated successfully.' : 'Your Control Group Population has been added successfully.' }}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button v-if="!submiting" variant="outline-danger" @click="resetModal">Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          variant="outline-success"
          @click="checkValidation()"
        >{{ editControlGroup? 'Update' : 'Save' }}</b-button>
      </template>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Delete Field"
      v-model="showDeleteControlGroupModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <p>Are you sure you want to delete this Control Group Population ?</p>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>Control Group Population is being deleting......</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            Control Group Population has been deleted successfully.
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button v-if="!submiting" @click="resetDeleteModal">Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          variant="danger"
          @click="deleteControlGroupCall()"
        >
          <font-awesome-icon
            v-b-tooltip.hover
            title="Delete Field"
            class="mr-1 text-light"
            icon="trash"
          />Yes
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import AppLoader from "../../components/Loader/Loader";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "PriControlGroupsPopulation",
  mixins: [validationMixin],
  components: {
    AppLoader
  },
  data() {
    return {
      showDeleteControlGroupModal: false,
      controlGroupId: null,
      form: {
        selectedControlGroup: []
      },
      selectedThirdPartyValue: [],
      selectedThirdPartyId: [],
      selectedThirdPartyName: [],
      editControlGroup: false,
      thirdPartyOptions: [],
      showModal: false,
      isLoading: false,
      tableFields: [
        { key: "created_at", label: "Age", sortable: true },
        { key: "control_group_title", label: "Title", sortable: true },
        {
          key: "count_third_party_id",
          label: "No. Of Subjects",
          sortable: true
        },
        { key: "pri_title", label: "PRI Catgeories", sortable: true },
        { key: "actions", label: "Actions", sortable: false }
      ],
      controlGroupOptions: [],
      filter: null,
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      submiting: false,
      responseSuccess: false,
      isLoadingThirdParty: false,
      thirdPartyFields: [
        { key: "comp_name_eng", label: "Third Party Name" },
        { key: "tpi_type", label: "Entity Type" },
        { key: "country", label: "Country" },
        { key: "selectThirdParty", label: "Select Third Party" }
      ],
      thirdPartyTotalRows: 0,
      thirdPartyIsLoading: false,
      thirdPartyFilter: null,
      thirdPartyPerPage: 10,
      thirdPartyCurrentPage: 1,
      thirdPartySortBy: "id",
      thirdPartySortDesc: true,
      thirdPartyPageOptions: [5, 10, 25, 50, 75, 100]
    };
  },
  validations: {
    form: {
      selectedControlGroup: { required }
    }
  },
  computed: {
    rows() {
      return this.totalRows;
    },
    thirdPartyRows() {
      return this.thirdPartyTotalRows;
    }
  },
  mounted() {
    this.getControlGroupOptions();
  },
  methods: {
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "my-table");
    },
    async getControlGrouppopulationTableData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
        company_id: this.$route.params.id
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP(
        "post",
        "v1/control-group/get-control-group-population-list",
        formData,
        {
          Authorization: token
        }
      );

      return result
        .then(response => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          return [error];
        });
    },
    async getThirdPartiesList() {
      let formData = {
        filter: this.thirdPartyFilter,
        sort:
          this.thirdPartySortBy +
          "|" +
          (this.thirdPartySortDesc == true ? "desc" : "asc"),
        per_page: this.thirdPartyPerPage,
        page: this.thirdPartyCurrentPage,
        company_id: this.$route.params.id
      };
      this.thirdPartyIsLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = HTTP("post", "v1/getthirdPartiestable", formData, {
        Authorization: token
      });

      return result
        .then(response => {
          const items = response.data.data;
          this.thirdPartyIsLoading = false;
          this.thirdPartyTotalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.thirdPartyIsLoading = false;
          return [error];
        });
    },
    onSelectedThirdParty(data) {
      this.selectedThirdPartyId.push(data.item.id);
      this.selectedThirdPartyName.push(data.item.comp_name_eng);
    },
    deleteSelectedThirdParty(index) {
      this.selectedThirdPartyId.splice(index, 1);
      this.selectedThirdPartyName.splice(index, 1);
    },
    async getControlGroupOptions() {
      this.controlGroupOptions = [];
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "get",
          "v1/control-group/getcontrolgroup/" + this.$route.params.id,
          null,
          {
            Authorization: token
          }
        );
        this.controlGroupOptions = result.data.controlgroup;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    resetModal() {
      this.form.selectedControlGroup = [];
      this.selectedThirdPartyId = [];
      this.selectedThirdPartyName = [];
      this.selectedThirdPartyValue = [];
      this.editControlGroup = false;
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
      this.$v.form.$reset();
      this.showModal = false;
    },
    checkValidation() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else if (this.editControlGroup) {
        this.updateControlGroupPopulation().then(this.reloadTable);
      } else {
        this.saveControlGroupPopulation().then(this.reloadTable);
      }
    },
    async saveControlGroupPopulation() {
      let formData = {
        control_group_ids: this.form.selectedControlGroup,
        third_party_ids: this.selectedThirdPartyId,
        created_by_id: localStorage.getItem("userId")
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        await HTTP(
          "post",
          "v1/control-group/create-control-group-population",
          formData,
          {
            Authorization: token
          }
        );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        this.form.selectedThirdParty = [];
        this.selectedThirdPartyId = [];
        this.selectedThirdPartyName = [];
        this.form.selectedControlGroup = [];
      } catch (err) {
        return [err];
        // // console.log("------------erroror", err);
      }
    },
    onEditControlGroup(data) {
      this.editControlGroup = true;
      this.controlGroupId = data.item.id;
      this.form.selectedControlGroup.push(data.item.id);
      this.getThirdPartyValue(data.item.id);
      this.showModal = true;
    },
    async getThirdPartyValue(controlGroupId) {
      this.isLoadingThirdParty = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      try {
        let result = await HTTP(
          "get",
          "v1/control-group/get-control-group-population-third-party-ids/" +
            controlGroupId,
          null,
          {
            Authorization: token
          }
        );
        result.data.map(ids => {
          this.selectedThirdPartyId.push(ids.third_party_id);
          this.selectedThirdPartyName.push(ids.comp_name_eng);
        });
        this.isLoadingThirdParty = false;
      } catch (error) {
        this.isLoadingThirdParty = false;
      }
    },
    async updateControlGroupPopulation() {
      let formData = {
        control_group_id: this.controlGroupId,
        control_group_ids: this.form.selectedControlGroup,
        third_party_ids: this.selectedThirdPartyId,
        created_by_id: localStorage.getItem("userId")
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        await HTTP(
          "post",
          "v1/control-group/update-control-group-population",
          formData,
          {
            Authorization: token
          }
        );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        this.form.selectedThirdParty = [];
        this.selectedThirdPartyId = [];
        this.selectedThirdPartyName = [];
        this.form.selectedControlGroup = [];
      } catch (err) {
        return [err];
        // // console.log("------------erroror", err);
      }
    },
    onDeleteControlGroupModal(data) {
      this.controlGroupId = data.item.id;
      this.showDeleteControlGroupModal = true;
    },
    deleteControlGroupCall() {
      this.deleteControlGroup().then(this.reloadTable);
    },
    async deleteControlGroup() {
      this.isLoading = true;
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        await HTTP(
          "get",
          "v1/control-group/deletecontrolgrouppopulation/" +
            this.controlGroupId,
          null,
          {
            Authorization: token
          }
        );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (error) {
        this.isLoading = false;
      }
    },
    resetDeleteModal() {
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
      this.showDeleteControlGroupModal = false;
    }
  }
};
</script>

<style scoped>
</style>
